import {
  GraphQLObjectType,
  GraphQLNonNull,
  GraphQLBoolean,
  GraphQLList,
  GraphQLEnumType,
  GraphQLInputObjectType
} from 'graphql'
import { vulnerabilitySeverityType } from './vulnerability'
// TODO Verify if this should stay here or be moved to separate files
export interface StatusApprovalWorkflowSettings {
  readonly enabled: boolean
  readonly statuses: string[]
  readonly severities: string[]
}

const workflowVulnerabilityStatusType = new GraphQLEnumType({
  name: 'WorflowVulnerabilityStatus',
  description:
    'Vulnerability statuses that can be subject to the status approval workflow',
  values: {
    NotAProblem: {
      value: 'NotAProblem'
    },
    Remediated: {
      value: 'Remediated'
    },
    Fixed: {
      value: 'Fixed'
    },
    AutoRemediated: {
      value: 'AutoRemediated'
    }
  }
})

const fields = {
  enabled: {
    type: new GraphQLNonNull(GraphQLBoolean)
  },
  statuses: {
    description:
      'Vulnerability statuses that require admin approval before they can be applied. An empty list for this argument will enable approval workflow for all statuses.',
    type: new GraphQLNonNull(
      new GraphQLList(new GraphQLNonNull(workflowVulnerabilityStatusType))
    )
  },
  severities: {
    description:
      'Vulnerability severities that require admin approval before the status of the vulnerability can be changed. An empty list for this argument will enable approval workflow for severities.',
    type: new GraphQLNonNull(
      new GraphQLList(new GraphQLNonNull(vulnerabilitySeverityType))
    )
  }
}

export const statusApprovalWorkflowSettingsType = new GraphQLObjectType({
  name: 'StatusApprovalWorkflowSettings',
  fields: () => fields
})

export const statusApprovalWorkflowSettingsInputType =
  new GraphQLInputObjectType({
    name: 'StatusApprovalWorkflowSettingsInput',
    fields: () => fields
  })
